// extracted by mini-css-extract-plugin
module.exports = {"Map":"Map_Map__3BDgm"};